export class MeiliSearchError extends Error {
    name = "MeiliSearchError";
    constructor(...params) {
        super(...params);
    }
}
//# sourceMappingURL=meilisearch-error.js.map